import { LOAD_SERVICE_ACTIVE_LOG, REMOVE_LISTS } from './actions'

const initialState = {
  // *load ข้อมูล service active log
  log_list: [],
  check_log_list: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState
    case LOAD_SERVICE_ACTIVE_LOG.REQUEST:
      return {
        ...state,
        log_list: [],
        check_log_list: true,
      }
    case LOAD_SERVICE_ACTIVE_LOG.SUCCESS:
      return {
        ...state,
        log_list: action.payload.lists || [],
        check_log_list: false,
      }

    default:
      return state
  }
}
